var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.open ? 'faq open' : 'faq',on:{"click":function($event){return _vm.$emit('toggleOpen', _vm.indexFaq, _vm.indexFaqCategory)}}},[_c('div',{staticClass:"question",domProps:{"innerHTML":_vm._s(_vm.faq.question)}}),_c('div',{staticClass:"answer",domProps:{"innerHTML":_vm._s(_vm.faq.answer)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }